import { supabase } from '@/lib/supabase'

/** A refused download; `message` is the backend's Dutch text when it sent one. */
export class DownloadError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'DownloadError'
  }
}

/**
 * GET `path` with the session's bearer token and save the response as a file (the
 * name from Content-Disposition, else `fallbackName`). Shared by the import template,
 * the import report and the RVO export (spec-60 B2).
 */
export async function downloadFile(path: string, fallbackName: string): Promise<void> {
  const {
    data: { session },
  } = await supabase.auth.getSession()
  const headers: Record<string, string> = {}
  if (session?.access_token) headers.Authorization = `Bearer ${session.access_token}`
  const response = await fetch(path, { headers })
  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { message?: unknown } | null
    throw new DownloadError(
      typeof body?.message === 'string' ? body.message : `Downloaden mislukt (${response.status})`,
    )
  }
  const disposition = response.headers.get('Content-Disposition') ?? ''
  const filename = /filename="([^"]+)"/.exec(disposition)?.[1] ?? fallbackName
  const url = URL.createObjectURL(await response.blob())
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.click()
  URL.revokeObjectURL(url)
}
